<template>
  <div v-if="dBrainClient && client && compareData.length" class="border border-top-0 rounded rounded-top-0 mb-2 p-2">
    <div class="border-bottom mb-2">
      <div class="row">
        <div class="col-4 text-gray-700">
          Поле
        </div>
        <div class="col-8 row">
          <div class="col-4 text-center text-gray-700">
            ЕСБД
          </div>
          <div class="col-4 text-center">

          </div>
          <div class="col-4 text-center text-gray-700">
            Скан
          </div>
        </div>
      </div>
    </div>
    <div v-for="(item, index) in compareData" :key="index" :class="{'border-bottom': index !== compareData.length - 1}">
      <div class="row">
        <div class="col-4 text-gray-700">
          {{getFieldLabel(item.key)}}
        </div>
        <div class="col-8 row">
          <div class="col-4 text-center text-danger">
            {{item.source ?? '-'}}
          </div>
          <div class="col-4 text-center">
            ←
          </div>
          <div class="col-4 text-center text-success">
            {{item.target ?? '-'}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerChange',
  props: {
    dBrainClient: {
      type: Object,
      default: null
    },
    client: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
       compareData: [],
    }
  },
  methods: {
    compareValues(target, source, changeId = false, path = "", compareData = []) {
      const blacklist = [
        "filter.verify",
        "client.politician",
        "client.id",
        "document.valid",
        "podft.success",
        "podft.message",
        "podft.setDocument",
        "driver.age_experience_id",
        "driver.experience",
        "driver.pensioner",
        "driver.age",
        "beingVerify"
      ];

      for (const key in target) {
        if (source.hasOwnProperty(key)) {
          const fullPath = path ? `${path}.${key}` : key;
          if (blacklist.includes(fullPath)) continue;
          if (!changeId && fullPath === 'client.id') continue; // можно убрать, т.к. уже есть в blacklist
          const targetVal = target[key];
          const sourceVal = source[key];

          if (
              typeof targetVal === "object" &&
              targetVal !== null &&
              !Array.isArray(targetVal)
          ) {
            this.compareValues(targetVal, sourceVal, changeId, fullPath, compareData);
          } else {
            const isTargetEmpty = targetVal === undefined || targetVal === null || targetVal === '';
            const isEqual = targetVal == sourceVal;

            if (!isTargetEmpty && !isEqual) {
              compareData.push({
                key: fullPath,
                source: sourceVal,
                target: targetVal,
              });
            }
          }
        }
      }
      return compareData;
    },
    getFieldLabel(path) {
      const parts = path.split(".");
      let current = this.ruDictionary();

      for (const part of parts) {
        if (current && typeof current === 'object' && part in current) {
          current = current[part];
        } else {
          return path;
        }
      }

      return typeof current === "string" ? current : path;
    },
    ruDictionary() {
      return {
        filter: {
          resident: "Резидент",
          person: "Физическое лицо",
          verify: "Прошел проверку",
        },
        client: {
          title: "Обращение",
          surname: "Фамилия",
          name: "Имя",
          patronymic: "Отчество",
          surname_eng: "Фамилия (латиницей)",
          name_eng: "Имя (латиницей)",
          patronymic_eng: "Отчество (латиницей)",
          economics_sector_id: "Сектор экономики",
          activity_kind_id: "Вид деятельности",
          country_id: "Гражданство",
          politician: "Является политиком",
          birthday: "Дата рождения",
          address: "Адрес",
          phone: "Телефон",
          email: "Email",
          iin: "ИИН",
          sex: "Пол",
          id: "ID клиента"
        },
        document: {
          valid: "Документ действителен",
          type_id: "Тип документа",
          number: "Номер документа",
          issuer: "Кем выдан",
          issued: "Дата выдачи",
          until: "Срок действия"
        },
        location: {
          country_id: "Страна проживания",
          address: "Адрес проживания"
        },
        class: {
          class_id: "Класс клиента (ID)",
          class: "Класс клиента"
        },
        podft: {
          success: "Результат ПОД/ФТ проверки",
          message: "Сообщение ПОД/ФТ",
          setDocument: "Документ установлен"
        },
        driver: {
          age_experience_id: "ID опыта по возрасту",
          experience: "Есть опыт вождения",
          pensioner: "Пенсионер",
          age: "Возраст"
        },
        beingVerify: "Находится на проверке"
      };
    }
  },
  watch: {
    dBrainClient: {
      deep: true,
      immediate: true,
      handler() {
        if (this.dBrainClient && this.client) {
          this.compareData = this.compareValues(this.dBrainClient, this.client);
        }
      }
    }
  }
}
</script>

<style>
</style>